import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import Notification from 'src/pages/Notification';
import Application from 'src/pages/Application';
import User from 'src/pages/User';



const routes = [
  {
    path: 'app',
    element: <DashboardLayout />,
    children: [
      { path: 'notification', element: <Notification /> },
      { path: 'application', element: <Application /> },
      { path: 'user', element: <User /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  },
  {
    path: '/',
    element: <MainLayout />,
    children: [
      { path: 'login', element: <Login /> },
      { path: '404', element: <NotFound /> },
      { path: '/', element: <Navigate to="/login" /> },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
